export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-v1-960-cd96e0ea1f204e28f17f5a77a8810638.webp";